import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { ChatTeamMemberDrawerService } from '../../services/chat-team-drawer.service';
import { ChatTeamMemberFormComponent } from '../chat-team-member-form/chat-team-member-form.component';
import { ChatTeamMemberAdmin } from '../../models/chat-team-admin.model';

@Component({
  selector: 'app-chat-team-member-form-drawer',
  standalone: true,
  imports: [CommonModule, ChatTeamMemberFormComponent],
  template: `
    @if (isOpen) {
      <div class="fixed inset-0 z-[99999] bg-black/40" (click)="close()"></div>
    }
    <div
      class="fixed top-0 right-0 z-drawer h-full w-full max-w-md bg-white dark:bg-gray-900 flex flex-col transition-transform duration-300 ease-in-out overflow-hidden"
      [class.shadow-2xl]="isOpen"
      [class.translate-x-0]="isOpen"
      [class.translate-x-full]="!isOpen">
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ optionsId ? 'Editar miembro' : 'Agregar miembro' }}
        </h2>
        <button type="button" (click)="close()" class="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-800">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      <div class="flex-1 overflow-y-auto">
        @if (isOpen) {
          <app-chat-team-member-form (saved)="onSaved($event)" (cancelled)="close()" />
        }
      </div>
    </div>
  `
})
export class ChatTeamMemberFormDrawerComponent implements OnInit, OnDestroy {
  @ViewChild(ChatTeamMemberFormComponent) formComponent?: ChatTeamMemberFormComponent;
  isOpen = false;
  optionsId: number | undefined;
  private readonly destroy$ = new Subject<void>();

  constructor(private drawerService: ChatTeamMemberDrawerService) {}

  ngOnInit(): void {
    this.drawerService.state.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      this.isOpen = state.isOpen;
      this.optionsId = state.options.id;
      const teamId = state.options.parentId;
      if (state.isOpen && teamId) {
        // El form solo existe cuando el drawer está abierto (@if): hay que esperar un tick.
        setTimeout(() => {
          this.formComponent?.reset(teamId);
          if (state.options.id) {
            this.formComponent?.loadMember(teamId, state.options.id);
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSaved(member: ChatTeamMemberAdmin): void {
    this.drawerService.notifySaved(member);
    this.close();
  }

  close(): void {
    this.drawerService.close();
  }
}
